import useRouter from "@casino/legacy/client/hooks/router/useRouter";
import SessionStorage from "@casino/legacy/shared/utils/storage/SessionStorage";

const menuUrlPattern = /^(.*(\?modal=menu))$/g;

const usePreviousPath = () => {
  const { asPath } = useRouter();
  const isIgnoredPath = !!asPath.match(menuUrlPattern);

  const savePreviousPath = () => {
    if (!isIgnoredPath) {
      SessionStorage.setItem("previousPath", asPath);
    }
  };

  const getPreviousPath = (): string | undefined =>
    SessionStorage.getItem("previousPath", "/");

  return {
    savePreviousPath,
    getPreviousPath,
  };
};

export default usePreviousPath;
